import { Container, Grid, rem, useMantineTheme } from '@mantine/core';

/**
 * Parameters of the SimpleLayout component.
 */
export interface SimpleLayoutProps {
  children: React.ReactNode | React.ReactNode[];
  contentStyle?: React.CSSProperties;
}

/**
 * Simple layout used for pages that don't need a navbar or header.
 */
export default function SimpleLayout({ children, contentStyle = {} }: SimpleLayoutProps) {
  const theme = useMantineTheme();

  return (
    <Grid justify="center" align="center" columns={1} style={{ margin: rem(0) }}>
      <Grid.Col
        span={1}
        h="100vh"
        display="flex"
        style={{ alignItems: 'center', justifyContent: 'center', background: theme.colors.gray[1] }}
      >
        <Container bg="#FFF" w={384} p={0} style={{ borderRadius: rem(4), ...contentStyle }}>
          {children}
        </Container>
      </Grid.Col>
    </Grid>
  );
}
